import * as actions from './actions';
import reducers from './reducers';

export default {
  actions,
  reducers,
};
